import { Carousel } from "@jewlr/storybook/core"
import { createSelector } from "@reduxjs/toolkit"
import PropTypes from "prop-types"
import { useState } from "react"
import { useSelector } from "react-redux"
import styled from "styled-components"

import Expand from "components/ui/expand"
import Media from "components/ui/media"
import { hideScrollbar } from "styles/utils"

import ExclusiveAddon from "./addon"

const AddonsCarousel = styled(Carousel)`
  ${hideScrollbar}
`

const selectPremiumGiftOffers = createSelector(
  [(state) => state.cart.addons, (state) => state.cart.premium_gift_offers],
  (addons, premiumGiftOffers) => {
    const filteredAddons = addons.filter((addon) =>
      ["BUNDLE", "GIFT_CARD"].includes(addon.addon_type)
    )

    return premiumGiftOffers.map((offer) => ({
      addons: filteredAddons.filter((addon) => addon.addon_code === offer.code),
      ...offer,
    }))
  }
)

const ExclusiveAddons = ({
  disableActions,
  refs,
  setAddonInModal,
  toggleAddonModal,
  toggleDisableActions,
}) => {
  const [showAddonDetail, toggleAddonDetail] = useState(false)
  const [addonInDetail, setAddonInDetail] = useState({})
  const premiumGiftOffers = useSelector(selectPremiumGiftOffers)

  return (
    <>
      <Media className="mx-16 mt-32" greaterThanOrEqual="tablet">
        <h4 className="text-26 leading-30 mb-16 font-medium capitalize">
          Save on these Exclusive Add-on Deals!
        </h4>
        <div className="contained">
          <AddonsCarousel
            displayArrows={{
              desktop: premiumGiftOffers?.length > 5 ? "flex" : "none",
              tablet: premiumGiftOffers?.length > 3 ? "flex" : "none",
            }}
            justifyContent={{
              desktop: premiumGiftOffers?.length > 5 ? "flex-start" : "center",
              tablet: premiumGiftOffers?.length > 3 ? "flex-start" : "center",
            }}
          >
            {premiumGiftOffers &&
              premiumGiftOffers.map((item, i) => {
                return (
                  <ExclusiveAddon
                    addonInDetail={addonInDetail}
                    disableActions={disableActions}
                    item={item}
                    key={`${item.code}-${i}`}
                    refs={refs}
                    setAddonInDetail={setAddonInDetail}
                    setAddonInModal={setAddonInModal}
                    toggleAddonDetail={toggleAddonDetail}
                    toggleAddonModal={toggleAddonModal}
                    toggleDisableActions={toggleDisableActions}
                  />
                )
              })}
          </AddonsCarousel>
        </div>
      </Media>
      <Expand id="cart-exclusive-addon-details" show={showAddonDetail}>
        <div className="bg-grey-4 mb-24 p-24">
          <h5 className="text-12 leading-14 mb-8 font-bold">
            {addonInDetail.title}
          </h5>
          <p className="text-12 leading-14 font-medium">
            {addonInDetail.description}
          </p>
        </div>
      </Expand>
    </>
  )
}

ExclusiveAddons.propTypes = {
  disableActions: PropTypes.object,
  refs: PropTypes.object,
  setAddonInModal: PropTypes.func,
  toggleAddonModal: PropTypes.func,
  toggleDisableActions: PropTypes.func,
}

export default ExclusiveAddons
